import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';
import { routes } from './routes.js';
import vueJquery from 'vue-jquery';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import axios from 'axios';
import VueAxios from 'vue-axios';
import browserDetect from "vue-browser-detect-plugin";
import VModal from 'vue-js-modal';

// Handle NavigationDuplicated Warning
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err;
  });
};

// Configure plugins
Vue.use(VModal, { dynamic: true, injectModalsContainer: true });
Vue.use(VueRouter);
Vue.use(VueAxios, axios);
Vue.use(vueJquery);
Vue.use(BootstrapVue);
Vue.use(browserDetect);

// Configure VueRouter
const router = new VueRouter({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes
});



//Vue.prototype.$hostname = 'https://test.samenfris.nl'; // TEST

Vue.prototype.$hostname = 'https://samenfris.nl'; // PRODUCTION

// Initialize Vue instance
new Vue({
  el: '#app',
  router,
  render: h => h(App)
});
